import { asyncRouterMap, constantRouterMap,constantRouterComponents } from '@/config/router.config'

/**
 * 过滤账户是否拥有某一个权限，并将菜单从加载列表移除
 *
 * @param permission
 * @param route
 * @returns {boolean}
 */
function hasPermission (permission, route) {
  if (route.meta && route.meta.permission) {
    let flag = false
    for (let i = 0, len = permission.length; i < len; i++) {
      flag = route.meta.permission.includes(permission[i])
      if (flag) {
        return true
      }
    }
    return false
  }
  return true
}

/**
 * 单账户多角色时，使用该方法可过滤角色不存在的菜单
 *
 * @param roles
 * @param route
 * @returns {*}
 */
// eslint-disable-next-line
function hasRole(roles, route) {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.includes(roles.id)
  } else {
    return true
  }
}

function filterAsyncRouter (routerMap, roles) {
  const accessedRouters = routerMap.filter(route => {
    if (hasPermission(roles.permissionList, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

function builderPermission(permissionList){
	let permission = [];
	for (let i=0;null !=permissionList && i<permissionList.length;i++) {
		permission.push(permissionList[i]);
	}
	
	console.log(permissionList)
	console.log(permission)
	return permission;
}
// 递归构建子菜单
function builderChildrenRouter (routerMap, parentRouter) {
    const accessedRouters = routerMap.map(item => {
        const currentRouter = {
                // 路由地址结果 eg: /dashboard/analysis
                path: `/${parentRouter.url}/${item.url}`,
                name: item.key,
                component: constantRouterComponents[item.url],
                // 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
                meta: { title: item.title,keepAlive: true || null,permission: builderPermission(item.permission)}
            }
        if (item.children && item.children.length > 0) {
            currentRouter.children = builderChildrenRouter (item.children, item)
        }
        return currentRouter
    })
		return accessedRouters
} 
const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },
  actions: {
    GenerateRoutes ({ commit }, data) {
      return new Promise(resolve => {
        const { menuList } = data  
				
				const accessedRouters = menuList.map(item => {
					 console.log("item:"+item.key)
						// 一级菜单
						const currentRouter = {
										path: `/${item.url}`,
										name: item.key,
										// 获取页面 layout
										component: constantRouterComponents[item.component || item.url],
										meta:  { title: item.title,icon: item.icon|| null, permission: [ item.url ]}
								}
						// 有子菜单
						if (item.children && item.children.length > 0) {
								currentRouter.children = builderChildrenRouter(item.children, item)
						}
						return currentRouter
				}) 
			 
			 
			 
			 const one = {
				path: '/',
				name: 'index',
				component: constantRouterComponents['BasicLayout'],
				meta: { title: '首页' },
				redirect: '/dashboard/workplace',
				children:[]
				}
				accessedRouters.map(item => {
					one.children.push(item)
					})
				
        commit('SET_ROUTERS', [one])
        resolve()
      })
    }
  }
}

export default permission
